import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RadioButton from '../../../ZUILib/RadioButton';

import { saveNearByStores } from '../../../../pages/NewHeader/actions';

class StoresRelatedSelection extends Component {
  constructor(props) {
    super(props);
    const initialState = {
      checked: false,
      favoriteStore: '',
    };

    this.state = { ...initialState };
  }

  componentDidMount() {
    const { favoriteStore } = this.state;
    if (!favoriteStore) this.cleanStateBeforeCloseMod();
  }

  cleanStateBeforeCloseMod = () => {
    this.setState({ ...this.initialState });
  }

  handleSwitchRadio = (ref, event) => {
    const { currentTarget: { value } } = event;
    const { hideOverlay } = this.props;
    this.setState({
      ...this.state,
      checked: (value === ref.value), // TODO: Review and fixed
    });

    this.props.saveNearByStores(value);

    hideOverlay();
  }

  formatStoreName = ({ storeName, address, storeId, services, schedule }) => {
    const { handleModalDetails, showModalDetailsUpdate } = this.props;
    // const { checked } = this.state;

    const companyName = storeName.substring(0, storeName.indexOf(' '));
    const locationPlace = storeName.substring(storeName.indexOf(' ') + 1);

    return (
      <Fragment>
        <p><span>{companyName} - </span>{locationPlace}</p>
        <p
          onClick={() => {
            handleModalDetails({ storeName, address, storeId, services, schedule });
            setTimeout(() => {
              showModalDetailsUpdate(false, true);
            }, 500);
          }}
        > Ver detalles </p>
      </Fragment>
    );
  }

  render() {
    const { storeByNear } = this.props;
    const { data = [] } = storeByNear || {};

    return (
      <div className="storesRelatedSelection alignmentRow">
        <ul className="resetUlStyles">
          {
            data.map(item => (
              <li>
                <div className="radioSelectionStore">
                  <RadioButton
                    radioCssClass={'radio'}
                    name={item.storeName}
                    onChangeFunction={this.handleSwitchRadio}
                    value={item.storeId}
                    // checked={this.state.checked}
                  />
                </div>
                <div className="storeAndDetails">
                  {this.formatStoreName({ ...item })}
                </div>
              </li>
            ))
          }
        </ul>
      </div>
    );
  }
}

const matchDispatchToProps = dispatch => bindActionCreators({
  saveNearByStores,
}, dispatch);

export default connect(null, matchDispatchToProps)(StoresRelatedSelection);

